<template>
  <div
    class="unhandled"
    :class="{
      'is-us': isSelectedUs,
      'is-tw': isSelectedTw,
      'is-cn': isSelectedCn,
    }"
  >
    <b-container fluid>
      <h1>Error</h1>
      <h2 class="h4">{{ $t('error.systemError') }}</h2>
      <p class="lead" :class="{ 'is-jp': isSelectedJp }">{{ $t('error.unknownError') }}</p>
      <p>{{ $t('error.unknownErrorDescription') }}</p>
      <p>{{ $t('error.pleaseReload') }}</p>
      <b-button @click="reload">{{ $t('error.reload') }}</b-button>
    </b-container>
  </div>
</template>
<script>
export default {
  props: {
    language: {
      type: String,
      required: true,
    },
  },
  computed: {
    isRoot() {
      return this.$route.path === '/'
    },
    isSelectedJp() {
      return this.language === 'ja'
    },
    isSelectedUs() {
      return this.language === 'us'
    },
    isSelectedTw() {
      return this.language === 'zh-tw'
    },
    isSelectedCn() {
      return this.language === 'zh-cn'
    },
  },
  methods: {
    reload() {
      if (this.isRoot) {
        this.$router.push({ path: '/' })
      }
      location.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
.unhandled {
  display: flex;
  align-items: center;
  max-width: 470px;
  height: 100%;
  margin: 0 auto;
  text-align: center;

  &.is-us {
    max-width: 500px;
  }
  &.is-tw {
    max-width: 290px;
  }
  &.is-cn {
    max-width: 210px;
  }

  p {
    text-align: left;

    &.lead {
      text-align: center;

      &.is-jp {
        padding-left: 1em;
      }
    }
  }
}
</style>
